/**
* Content Accordion JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Accordion component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'content-accordion',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const desktopQuery = window.matchMedia( '(min-width: 1024px)' );

      document.querySelectorAll( this.selector() ).forEach( ( accordion ) => {
        if ( accordion.dataset.firstOpen !== 'true' ) return;

        const openFirstOnDesktop = () => {
          if ( !desktopQuery.matches ) return;

          const firstToggle = accordion.querySelector( '.easy-toggle-slide-toggle' );
          if ( firstToggle && !firstToggle.classList.contains( 'is-open' ) ) {
            const target = firstToggle.getAttribute( 'data-toggle-target' );
            const targetPanel = target ? accordion.querySelector( target ) : null;
            const group = firstToggle.getAttribute( 'data-toggle-group' );

            if ( group ) {
              accordion.querySelectorAll( `[data-toggle-group="${ group }"].is-open` ).forEach( ( toggle ) => {
                const openTarget = toggle.getAttribute( 'data-toggle-target' );
                const openPanel = openTarget ? accordion.querySelector( openTarget ) : null;

                toggle.classList.remove( 'is-open' );
                toggle.setAttribute( 'aria-expanded', 'false' );
                toggle.easyToggleState_isActive = false;

                if ( openPanel ) {
                  openPanel.classList.remove( 'is-open' );
                  openPanel.easyToggleState_isActive = false;
                  $( openPanel ).stop( true, true ).slideUp( 0 );
                }
              } );
            }

            firstToggle.classList.add( 'is-open' );
            firstToggle.setAttribute( 'aria-expanded', 'true' );
            firstToggle.easyToggleState_isActive = true;

            if ( targetPanel ) {
              targetPanel.classList.add( 'is-open' );
              targetPanel.easyToggleState_isActive = true;
              $( targetPanel ).stop( true, true ).slideDown( 0 );
            }
          }
        };

        requestAnimationFrame( openFirstOnDesktop );

        if ( desktopQuery.addEventListener ) {
          desktopQuery.addEventListener( 'change', openFirstOnDesktop );
        } else {
          desktopQuery.addListener( openFirstOnDesktop );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-accordion', COMPONENT );
} )( app );
